// import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Login } from "./pages/login";
import { PickTenant } from "./pages/pickTenant";
import { ResetPassword } from "./pages/resetPassword";
import { RequestPasswordReset } from "./pages/requestPasswordReset";
import { Toaster } from "@readouts/ui/sonner";

function App() {
  return (
    <>
      <Toaster />
      <Routes>
        <Route path="" element={<div>None</div>} />
        <Route path="/login" element={<Login />} />
        <Route path="/pick-tenant" element={<PickTenant />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/request-password-reset"
          element={<RequestPasswordReset />}
        />
      </Routes>
    </>
  );
}

export default App;
